(function () {
    'use strict';

    /**
     * Type definitions
     * 
     * @typedef Score
     * @type {0|1|2|3|4}
     * 
     * @typedef Feedback
     * @type {object}
     * @property {string} warning
     * @property {Array<string>} suggestions
     * 
     * @typedef StrengthCheckResult
     * @type {object}
     * @property {Score} score
     * @property {Feedback} feedback
     */

    angular.module('app').factory('passwordStrengthService', passwordStrengthService);

    passwordStrengthService.$inject = ["passwordPolicy", "settingsService", "zxcvbnts",];

    function passwordStrengthService(passwordPolicy, { locale }, zxcvbnts) {

        let zxcvbnInstance = null;

        const service = {
            check
        };

        return service;

        /**
         * Check the strength of the password.
         * @param {string} password
         * @return {StrengthCheckResult}
         */
        function check(password) {
            const strengthMeter = getZxcvbn(getOptions(passwordPolicy, locale));

            const { score, feedback } = strengthMeter.check(password);

            return { score, feedback };
        }


        function getZxcvbn(options) {
            return zxcvbnInstance ??= new zxcvbnts.core.ZxcvbnFactory(options);
        };

        function getOptions(passwordPolicy, locale) {
            const uiCulture = locale.toLowerCase();
            const language = `language-${uiCulture === "nl" ? "nl-be" : uiCulture}`;

            return {
                translations: zxcvbnts[language].translations,
                graphs: {
                    ...zxcvbnts['language-common'].adjacencyGraphs,
                    ...zxcvbnts[language].adjacencyGraphs,
                },
                dictionary: {
                    ...zxcvbnts['language-common'].dictionary,
                    ...zxcvbnts[language].dictionary,
                },
                maxLength: passwordPolicy.maximumLength
            };
        };
    }
})();
